import { render, staticRenderFns } from "./OrderCategories.vue?vue&type=template&id=1c8b4918&"
import script from "./OrderCategories.vue?vue&type=script&lang=js&"
export * from "./OrderCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports